import { createAction } from '@lingoda/core';

export default createAction<number>('auth/REMOVE_USER');
